import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import useSession from 'tennders-auth/hooks/useSession'
import GImage from 'tennders-market/common/components/element/GImage'
import GHref from 'tennders-market/common/components/element/GHref'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import Trans from 'next-translate/Trans'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

const AssignLoadButton = () => {
  const { t } = useTranslation()

  const [isFixed, toggle] = useTransactionDetailStore(
    state => [state.assignTruckLoadType, state.toggleLoadAssign]
  )

  return (
    isFixed
      ? (
        <GHref onClick={toggle} className="btn-border standard-btn medium">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-4" aria-hidden="true" />
          <Trans i18nKey="transaction:backToNegotiation" />
        </GHref>
      )
      : (
        <GHref
          onClick={toggle}
          className="btn-border standard-btn medium tennders-brokers-find-trucks-btn"
        >
          {t('transaction:assignLoads')}
        </GHref>
      )
  )
}

const FindLoadButton = ({ transaction, withIcon }) => {
  const { t } = useTranslation()
  const { isBroker } = useSession()

  const [isFixed, setAssignTruckLoadType] = useTransactionDetailStore(
    state => [state.assignTruckLoadType, state.setAssignTruckLoadType]
  )
  const toggle = () => {
    console.info('ttt', setAssignTruckLoadType)
    setAssignTruckLoadType('load-match')
  }

  if (!transaction?.isMarketPlaced && !isBroker()) {
    return null
  }

  if (transaction?.isPassive) {
    return null
  }

  if (transaction?.isBooked) {
    return <AssignLoadButton transaction={transaction} />
  }

  if (withIcon) {
    return (
      <GHref onClick={toggle}>
        <GImage width={32} className="m-auto" src="loads.svg" />
        {t('transaction:matchLoads')}
      </GHref>
    )
  }
  return (
    isFixed
      ? (
        <GHref onClick={toggle} className="btn-border standard-btn medium">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-4" aria-hidden="true" />
          <Trans i18nKey="transaction:backToNegotiation" />
        </GHref>
      )
      : transaction?.matchedTruck?.internalOwner
        ? (
          <GHref
            onClick={toggle}
            className="btn-border standard-btn medium tennders-brokers-find-trucks-btn"
          >
            {t('transaction:matchLoads')}
          </GHref>
        )
        : null
  )
}

export default FindLoadButton
